import { Link, NavLink } from "react-router-dom";

const channelLinks = [
  { to: "/category?genre=热血", label: "热血战斗" },
  { to: "/category?genre=奇幻", label: "奇幻冒险" },
  { to: "/category?genre=恋爱", label: "恋爱日常" },
  { to: "/category?genre=悬疑", label: "悬疑推理" },
  { to: "/category?genre=治愈", label: "治愈温暖" },
  { to: "/category?genre=古风", label: "古风仙侠" },
];

const siteLinks = [
  { to: "/", label: "首页" },
  { to: "/category", label: "动漫分类" },
  { to: "/news", label: "动漫资讯" },
  { to: "/search", label: "站内搜索" },
  { to: "/about", label: "关于我们" },
  { to: "/contact", label: "联系我们" },
];

export default function SiteFooter() {
  return (
    <>
    <footer className="w-full border-t border-background-200 bg-background-100">
      <div className="w-full px-4 pb-24 pt-12 md:px-8 md:py-16 lg:pb-16">
        <div className="grid grid-cols-1 gap-10 sm:grid-cols-2 lg:grid-cols-4">
          <div>
            <div className="flex items-center gap-2.5">
              <span className="flex h-10 w-10 items-center justify-center rounded-lg bg-primary-500 text-background-50">
                <span className="font-heading text-lg font-bold leading-none">樱</span>
              </span>
              <span className="font-heading text-lg font-bold text-foreground-950">樱花动漫官网</span>
            </div>
            <p className="mt-4 max-w-xs text-sm leading-relaxed text-foreground-600">
              一个为动画爱好者准备的综合平台。在这里找番、追番、读资讯，也可以安静地把喜欢的作品收进自己的收藏夹。
            </p>
            <div className="mt-5 flex items-center gap-2">
              {["ri-weibo-fill", "ri-wechat-fill", "ri-bilibili-fill", "ri-mail-line"].map((icon) => (
                <Link
                  key={icon}
                  to="/contact"
                  className="flex h-9 w-9 items-center justify-center rounded-md border border-background-300 bg-background-50 text-foreground-600 transition-colors hover:border-primary-300 hover:text-primary-600"
                  aria-label="社交媒体"
                >
                  <i className={`${icon} text-base`} />
                </Link>
              ))}
            </div>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold text-foreground-950">
              <Link to="/category">动漫频道</Link>
            </h4>
            <ul className="mt-4 space-y-2.5">
              {channelLinks.map((item) => (
                <li key={item.to}>
                  <Link to={item.to} className="text-sm text-foreground-600 transition-colors hover:text-primary-600">
                    {item.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold text-foreground-950">
              <Link to="/about">网站导航</Link>
            </h4>
            <ul className="mt-4 space-y-2.5">
              {siteLinks.map((item) => (
                <li key={item.to}>
                  <Link to={item.to} className="text-sm text-foreground-600 transition-colors hover:text-primary-600">
                    {item.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold text-foreground-950">联系我们</h4>
            <ul className="mt-4 space-y-3 text-sm text-foreground-600">
              <li className="flex items-start gap-2">
                <i className="ri-mail-line mt-0.5 text-base text-primary-500" />
                <span>hello@sakura-anime.example</span>
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-phone-line mt-0.5 text-base text-primary-500" />
                <span>400-800-2026（工作日 10:00-19:00）</span>
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-map-pin-line mt-0.5 text-base text-primary-500" />
                <span>上海市徐汇区漕溪北路 88 号 12 层</span>
              </li>
            </ul>
            <Link
              to="/contact"
              className="mt-5 inline-flex items-center gap-1.5 whitespace-nowrap rounded-md bg-primary-500 px-4 py-2 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
            >
              提交反馈
              <i className="ri-arrow-right-line text-sm" />
            </Link>
          </div>
        </div>

        <div className="mt-12 flex flex-col gap-3 border-t border-background-300/70 pt-6 text-xs text-foreground-500 sm:flex-row sm:items-center sm:justify-between">
          <p>© 2026 樱花动漫官网 · 本站内容为演示用途，不提供真实视频播放服务。</p>
          <div className="flex flex-wrap items-center gap-4">
            <Link to="/about" className="transition-colors hover:text-primary-600">
              关于我们
            </Link>
            <Link to="/contact" className="transition-colors hover:text-primary-600">
              意见反馈
            </Link>
            <span className="flex items-center gap-1">
              <i className="ri-heart-3-fill text-primary-500" />
              为热爱而建
            </span>
          </div>
        </div>
      </div>
    </footer>

    <nav className="fixed inset-x-0 bottom-0 z-40 border-t border-background-200 bg-background-50/95 pb-[env(safe-area-inset-bottom)] backdrop-blur-md lg:hidden">
      <div className="grid grid-cols-4">
        {[
          { to: "/", icon: "ri-home-5-line", label: "首页" },
          { to: "/category", icon: "ri-layout-grid-line", label: "分类" },
          { to: "/search", icon: "ri-search-line", label: "搜索" },
          { to: "/contact", icon: "ri-customer-service-2-line", label: "联系" },
        ].map((item) => (
          <NavLink
            key={item.to}
            to={item.to}
            end={item.to === "/"}
            className={({ isActive }) =>
              [
                "flex flex-col items-center gap-1 py-2.5 text-[10px] transition-colors",
                isActive ? "text-primary-600" : "text-foreground-500",
              ].join(" ")
            }
          >
            <i className={`${item.icon} text-lg`} />
            {item.label}
          </NavLink>
        ))}
      </div>
    </nav>
    </>
  );
}